import { AIEntityModel } from "src/store/models/entity/ai/entity";
import { AIHelperModel } from "src/store/models/entity/ai/helper";

export const encooAIModels = {
  entity: AIEntityModel,
  helper: AIHelperModel,
};
